/* eslint-disable import/no-default-export */
const breakpoints = {
    lgMax: window.matchMedia("screen and (max-width: 1199px)"),
    mobileMax: window.matchMedia("screen and (max-width: 767px)"),
    tabletMin: window.matchMedia("screen and (max-width: 768px)"),
    tabletPortrait: window.matchMedia("screen and (max-width: 991px)"),
};

export default breakpoints;
